
import React from "react";

// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";

function Players() {
  return (
    <>
      <div className="section section-dark text-center gradient-background-claro">
        <Container>
          <h2 className="title gradient-title"> Players </h2>
          <hr style={{ clear: 'both' }} />
          <Row>

            <Col md="6">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="/" onClick={(e) => e.preventDefault()} >
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/Libidoh.jpg")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="/" onClick={(e) => e.preventDefault()} >
                    <div className="author">
                      <CardTitle tag="h4"> De Sade Libidoh </CardTitle>
                      <h6 className="card-category"> Mortal Kombat Fan </h6>
                    </div>
                  </a>
                  <p className="card-description text-center">
                    All the support and help by giving me new opportunities to present the project!!
                  </p>
                </CardBody>
              </Card>
            </Col>

            <Col md="6">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="/" onClick={(e) => e.preventDefault()} >
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/Mcfly.jpg")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="/" onClick={(e) => e.preventDefault()} >
                    <div className="author">
                      <CardTitle tag="h4"> MCFLY </CardTitle>
                      <h6 className="card-category"> Founder of @ETC Elite Tournament Chile </h6>
                    </div>
                  </a>
                  <p className="card-description text-center">
                    Inviting me and giving me a unique opportunity to present the project to the public in Chile!!
                    </p>
                </CardBody>
              </Card>
            </Col>

          </Row>
        </Container>
      </div>
    </>
  );
}

export default Players;
